// Application configuration
export const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  
  // App Configuration
  APP_NAME: process.env.REACT_APP_NAME || 'Motovolt Admin Panel',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.5',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // Feature Flags
  FEATURES: {
    DARK_MODE: true,
    NOTIFICATIONS: true,
    ANALYTICS: false,
    DEBUG_MODE: process.env.NODE_ENV === 'development',
  },
  
  // UI Configuration
  UI: {
    SIDEBAR_WIDTH: 280,
    SIDEBAR_COLLAPSED_WIDTH: 64,
    HEADER_HEIGHT: 64,
    DRAWER_WIDTH: 400,
  },
  
  // API Configuration
  API: {
    TIMEOUT: 300000, // 5 minutes
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
  },
  
  // Storage Keys
  STORAGE_KEYS: {
    AUTH_TOKEN: 'motovolt_auth_token',
    REFRESH_TOKEN: 'motovolt_refresh_token',
    USER_DATA: 'motovolt_user_data',
    THEME_MODE: 'motovolt_theme_mode',
    REMEMBER_ME: 'motovolt_remember_me',
  },
};

export default config;
